import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, Sprite, TextStyle, Text, RenderTexture } from "pixi.js";
import Stars from "./stars";
import { isMobileOS } from "tools";
const MAX_COINS = 9999999;
export default class Header extends Container {
  constructor() {
    super();
    this.updateScore = this.updateScore.bind(this);
    this.maxScale = window.innerWidth * 0.7 / 1920;
    if (isMobileOS()) {
      this.maxScale = window.innerWidth * 1.6 / 1920;
    }
    this.initCoins();
    config.levelProgressionMode && this.initLevel();
  }
  initPic(path) {}
  initPlayers() {
    config.initPlayersProcess = false;
    config.ui && config.ui.setObjectifDatas && config.ui.setObjectifDatas();
  }

  // resetAllPlayers() {

  //     this.id = config.playersNumber;

  //     this.rank = parseInt(tools.range(config.scoreRangeMin, config.scoreRangeMax));

  //     config.player.rank = this.rank;

  // }

  initOldScore(score) {}
  initCoins() {
    const coinsStyle = new TextStyle({
      fontFamily: "Anja Eliane accent",
      fontSize: 22,
      fill: "#ffffff"
    });
    config.coinsContainer = new Container();
    this.addChild(config.coinsContainer);
    this._coins = 0;
    this.coinsText = new Text(this._coins, coinsStyle);
    this.coinsText.anchor.set(0.5, 0.5);
    config.coinsContainer.addChild(this.coinsText);
    this._coinsPico = new Sprite(assets.textures.coins.texture);
    this._coinsPico.scale.set(this.maxScale);
    this._coinsPico.anchor.set(1.1, 0.5);
    config.coinsContainer.addChild(this._coinsPico);
    this.stars = new Stars(5, {
      x: 0,
      y: 0,
      w: 40,
      h: 50
    }, 1.5);
    this.stars.x = this._coinsPico.x - 20;
    // this.stars.show();
    // this.stars.loop = true;
    // this.stars.debug = true;
    this.stars.scaleMax = 0.4;
    config.coinsContainer.addChild(this.stars);
  }
  initLevel() {
    const PopTitleStyle = new TextStyle({
      fontFamily: "Anja Eliane accent",
      fontSize: 54,
      fill: "#b5520c",
      //#0b2944
      align: "center",
      // --- Drop Shadow Settings ---
      dropShadow: true,
      dropShadowColor: "#333333",
      // Color of the shadow (usually black)
      dropShadowBlur: 1,
      // Softness of the shadow
      dropShadowAngle: Math.PI / 6,
      // Direction (in radians, e.g., 30 degrees)
      dropShadowDistance: 1,
      // How far the shadow sits from the text
      dropShadowAlpha: 0.3 // Opacity of the shadow
    });
    this.levelTextTitle = new Text(assets.local.LEVEL, PopTitleStyle);
    this.levelTextTitle.anchor.set(0.5, 0.5);
    this.addChild(this.levelTextTitle);
    const levelStyle = new TextStyle({
      fontFamily: "Anja Eliane accent",
      fontSize: 36,
      fill: "#fafad2"
    });
    this.levelText = new Text("", levelStyle);
    this.levelText.anchor.set(0.65, 0.5);
    this.addChild(this.levelText);
  }
  debug(msg) {
    /*
        const style = new TextStyle({
            fontFamily: 'Anja Eliane accent',
            fontSize: 25,
            fill: '#ffffff'
        });
          let texte = new Text(msg, style)
        let renderTexture = new RenderTexture.create({ width: texte.width, height: texte.height });
        config.renderer.render(texte, { renderTexture });
        texte.destroy(true);
          if (this.scoreLabel) {
            this.scoreLabel.visible = false;
            this.scoreLabel.parent.removeChild(this.scoreLabel);
        }
          this.scoreLabel = new Sprite(renderTexture);
        this.scoreLabel.scale.set(.7);
        this.scoreLabel.x = 6;
        this.scoreLabel.y = 135;
        this.addChild(this.scoreLabel);
    */
  }
  updateScore() {
    config.ui.saveScore(config.currentScore);
  }
  updateLevel(animated) {
    if (animated) {
      gsap.delayedCall(0.7, () => {
        this.levelText.text = config.playerLevel;
        // gsap.to(this._levelPico.scale, { duration: .2, x: 1.5, y: 1.5 });
        // gsap.to(this._levelPico.scale, { delay: .2, duration: .8, x: .8, y: .8 });
        //this.levelStars.show();
      });
    } else {
      this.levelText.text = config.playerLevel;
    }
  }
  clearBots() {
    // Plus de bots
  }
  get bestScoreStep() {
    return this._bestScoreStep;
  }
  set bestScoreStep(val) {
    this._bestScoreStep = val;
  }

  //Coins

  setCoins(val) {
    gsap.to(this._coinsPico.scale, {
      duration: 0.2,
      x: this.maxScale + 0.2,
      y: this.maxScale + 0.2,
      yoyo: true,
      repeat: 1
    });
    for (let i = 0; i < val; i++) {
      gsap.delayedCall(0.1 * i, () => {
        config.coins++;
        this._coins = config.coins;
        this.coinsText.text = parseInt(this._coins > MAX_COINS ? MAX_COINS : this._coins);
      });
    }
    gsap.delayedCall(val * 0.2, () => {
      config.sdk.getStoreModule().save("coins", {
        value: config.coins
      });
    });
    val > 0 && this.stars.show();
    config.boosterMenu.greyMode = config.coins + val < 100;
  }
  set coins(val) {
    this._coins = val;
    this.coinsText.text = parseInt(this._coins > MAX_COINS ? MAX_COINS : this._coins);
    //gsap.to(this._coinsPico, { duration: .1, x: this.coinsText.x + this.coinsText.width*1.5 })
    gsap.to(this.stars, {
      duration: 0.1,
      x: this._coinsPico.x - 20
    });
    gsap.to(this._coinsPico.scale, {
      duration: 0.1,
      x: this.maxScale + 0.2,
      y: this.maxScale + 0.2
    });
    gsap.to(this._coinsPico.scale, {
      delay: 0.5,
      duration: 0.1,
      x: this.maxScale,
      y: this.maxScale
    });
    val > 0 && this.stars.show();
    config.boosterMenu.greyMode = config.coins < 100;
  }
  get coins() {
    return this._coins;
  }
  get coinsPico() {
    return this._coinsPico;
  }
  reseize(Ref, Ref2) {
    this.scale.y = 1;
    this.scale.x = 1;
    this.x = 0;
    this.y = 0;
    if (window.innerHeight > window.innerWidth) {
      //portrait mode
      this.coinsText.x = Ref.x + Ref.width * 0.31;
      this.coinsText.y = Ref.y - Ref.height * 0.31;
      this._coinsPico.x = Ref.x + Ref.width * 0.46;
      this._coinsPico.y = Ref.y - Ref.height * 0.32;
      this.coinsText.style.fontSize = Math.round(window.innerWidth * 0.038);
      this.levelText.x = Ref.x - Ref.width * 0.33;
      this.levelText.y = Ref.y + Ref.height * 0.36;
      this.levelText.style.fontSize = Math.round(window.innerWidth * 0.05);
      this.levelTextTitle.x = Ref.x - Ref.width * 0.33;
      this.levelTextTitle.y = Ref.y + Ref.height * 0.2;
      this.levelTextTitle.style.fontSize = Math.round(window.innerWidth * 0.04);
    } else {
      //landscape mode
      this.coinsText.x = Ref.x - Ref.width * 0.1;
      this.coinsText.y = Ref.y + Ref.height * 0.415;
      this.coinsText.style.fontSize = Math.round(window.innerHeight * 0.038);
      this._coinsPico.x = Ref.x + Ref.width * 0.45;
      this._coinsPico.y = Ref.y + Ref.height * 0.415;
      this.levelText.x = Ref2.x - Ref2.width * 0.36;
      this.levelText.y = Ref2.y + Ref2.height * 0.25;
      this.levelText.style.fontSize = Math.round(window.innerHeight * 0.05);
      this.levelTextTitle.x = this.levelText.x;
      this.levelTextTitle.y = Ref2.y - Ref2.height * 0.1;
      this.levelTextTitle.style.fontSize = Math.round(window.innerWidth * 0.02);
    }
  }
}
